import type { KkmServerCommandStatus } from './protocol';

export type KkmJournalPhase = 'request' | 'response' | 'threw' | 'timeout';
export type KkmJournalDeviceKind = 'acquiring' | 'kkt' | 'server';

/**
 * Сырое событие adapter-а. Идентификаторы страницы, tenant-контекст и
 * workstation дополняются feature-sink перед отправкой в GraphQL.
 */
export interface KkmJournalEvent {
  attempt: number;
  browserWorkstationId?: string | null;
  clientAt: string;
  clientEventId?: string;
  command: string;
  deviceKind: KkmJournalDeviceKind;
  /**
   * Событие фонового диагностического опроса. Только такие события журнал вправе
   * дедуплицировать: у решающих чтений намерение вызывающего по имени команды не видно.
   */
  diagnostic?: boolean;
  durationMs: number | null;
  errorCode: string | null;
  fiscalOperationId?: string | null;
  idCommand: string;
  idDevice: string | null;
  kkmserverVersion?: string | null;
  locationId?: string;
  pageSessionId?: string;
  payload: unknown;
  phase: KkmJournalPhase;
  refundId?: string | null;
  orderId?: string | null;
  shiftId?: string | null;
  status: KkmServerCommandStatus | null;
  userAgent?: string | null;
  vendorMessage: string | null;
  workstationId?: string | null;
}

export interface KkmJournalSink {
  record(event: KkmJournalEvent): void;
}

const NOOP_KKM_JOURNAL_SINK: KkmJournalSink = {
  record: (): void => undefined,
};

let journalSink: KkmJournalSink = NOOP_KKM_JOURNAL_SINK;

export function setKkmJournalSink(sink: KkmJournalSink): void {
  journalSink = sink;
}

export function getKkmJournalSink(): KkmJournalSink {
  return journalSink;
}
